import {
    CaseManagerControl,
    CaseNumberControl,
    CaseStatusControl,
    LocalCounselControl,
    PackageSettlementControl,
    UniqueCaseIDControl,
} from './StaticItemControls';
import {
    SameCaseApprovedHelperText,
    SameCasePendingHelperText,
} from '../../pages/quad/same-cases-admin/manage/useGetSameCasesQuery';

import { CaseFileStaticItems } from '../../utilities/Constants';
import { FieldControlWrapper } from './FieldControlWrapper';
import { IDisplayFieldModel } from '../../interfaces/IDisplaySectionModel';
import { ReactElement } from 'react';
import { useCaseFileContext } from '../../contexts/useCaseFileContext';

interface IStaticFieldRendererProps {
    displayAsCondensed: boolean;
    field: IDisplayFieldModel;
}

export function StaticFieldRenderer({ displayAsCondensed, field }: IStaticFieldRendererProps) {
    const {
        currentCase,
        isCaseApprovedInSameCaseGroup,
        isCasePendingInSameCaseGroup,
        isReadOnlyMode,
        staticItems,
    } = useCaseFileContext();

    let component: ReactElement | null = null;

    const found = staticItems.find((item) => item.guid === field.staticItemGuid);
    const isCaseInSameCaseGroup = !!isCaseApprovedInSameCaseGroup || !!isCasePendingInSameCaseGroup;

    switch (field.staticItemGuid) {
        case CaseFileStaticItems.CaseStatus.Guid:
            component = <CaseStatusControl />;
            break;
        case CaseFileStaticItems.CaseNumber.Guid:
            component = <CaseNumberControl isDisabled={isCaseInSameCaseGroup} />;
            break;
        case CaseFileStaticItems.LocalCounsel.Guid:
            component = <LocalCounselControl field={field} />;
            break;
        case CaseFileStaticItems.CaseManager.Guid:
            component = <CaseManagerControl isPrimary />;
            break;
        case CaseFileStaticItems.AlternateCaseManager.Guid:
            component = <CaseManagerControl isPrimary={false} />;
            break;
        case CaseFileStaticItems.UniqueCaseID.Guid:
            component = <UniqueCaseIDControl />;
            break;
        case CaseFileStaticItems.PackageSettlement.Guid:
            component = currentCase.packageSettlement ? <PackageSettlementControl /> : null;
            break;
        default:
            component = <div>Static Field Not Found!</div>;
    }

    if (!component) return null;

    const sameCaseHelpText = isCaseApprovedInSameCaseGroup
        ? SameCaseApprovedHelperText
        : isCasePendingInSameCaseGroup
          ? SameCasePendingHelperText
          : '';

    const isCaseNumberField = field.staticItemGuid === CaseFileStaticItems.CaseNumber.Guid;

    const sameCaseHelp =
        isCaseNumberField &&
        isCaseInSameCaseGroup &&
        !isReadOnlyMode &&
        (isCaseApprovedInSameCaseGroup || isCasePendingInSameCaseGroup)
            ? { text: sameCaseHelpText, title: found?.displayName ?? '' }
            : undefined;

    const help = found?.helpText
        ? { text: found?.helpText, title: found.displayName || '' }
        : sameCaseHelp;

    return (
        <FieldControlWrapper
            component={component}
            displayAsCondensed={displayAsCondensed}
            labelText={found?.displayName || found?.name || ''}
            identifier={field.staticItemGuid}
            help={help}
        />
    );
}
